import React from 'react'
import { func, number } from 'prop-types'
import media from '../../../utils/style'
import styled from 'styled-components'

const PaginationWrapper = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
  z-index: 3;

  ${media.MediumScreenUp`
    left: auto;
    transform: none;
    right: 50%;
    margin-right: 20px;
    margin-bottom: 20px;
    z-index: auto;
  `};
`

const Page = styled.div`
  border: none;
  padding: 6px;
  cursor: pointer;

  span {
    width: 10px;
    height: 10px;
    transition: all 0.1s ease-in-out;
    display: block;
    border-radius: 50%;
    background-color: ${(props) =>
      props.isActive
        ? props.theme.colors.grey_slate
        : props.theme.colors.blue_op30};
  }

  &:hover {
    span {
      background-color: ${(props) => props.theme.colors.grey_slate};
      transform: scale(1.1);
    }
  }

  ${media.MediumScreenUp`
    span {
      background-color: ${(props) =>
        props.isActive
          ? props.theme.colors.white
          : props.theme.colors.blue_light_op30};
    }

    &:hover {
      span {
        background-color: ${(props) => props.theme.colors.white};
      }
    }
  `}
`

export default function Pagination(props) {
  const { currentSlide, slideCount, onClick } = props
  return (
    <PaginationWrapper>
      {[...Array(slideCount).keys()].map((i) => {
        const isActive = currentSlide === i
        return (
          <Page
            key={`slide-index-${i}`}
            isActive={isActive}
            onClick={() => onClick(i)}
            aria-label={`Slide ${i + 1}`}
          >
            <span />
          </Page>
        )
      })}
    </PaginationWrapper>
  )
}

Pagination.propTypes = {
  currentSlide: number.isRequired,
  slideCount: number.isRequired,
  onClick: func.isRequired
}
